<!-- Copyright (c) 2009-2022. Authors: see NOTICE file.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.-->

<template>
<div>
  <b-loading :is-full-page="false" :active="loading" />
  <template v-if="!loading">
    <vl-map
      style="height: 750px"
      :data-projection="projectionName"
      :load-tiles-while-animating="true"
      :load-tiles-while-interacting="true"
    >
      <vl-view
        :center.sync="center"
        :zoom.sync="zoom"
        :max-zoom="maxZoom"
        :max-resolution="maxResolution"
        :extent="extent"
        :projection="projectionName"
      />

      <vl-layer-tile :extent="extent" ref="baseLayer">
        <vl-source-cytomine
          :projection="projectionName"
          :url="baseLayerURL"
          :tile-load-function="tileLoadFunction"
          :size="imageSize"
          :extent="extent"
          :nb-resolutions="maxZoom"
          :transition="0"
          :tile-size="[tileSize, tileSize]"
        />
      </vl-layer-tile>
    </vl-map>
  </template>
</div>
</template>

<script>

import {addProj, createProj, getProj} from 'vuelayers/lib/ol-ext';
import {Cytomine, AbstractSliceCollection} from 'cytomine-client';
import {get} from "@/utils/store-helpers";

export default {
  name: 'uploaded-file-details-viewer',
  props: {
    image: Object
  },
  data() {
    return {
      slice: null,
      loading: true,
      zoom: 2,
      center: null
    };
  },
  computed: {
    shortTermToken: get('currentUser/shortTermToken'),
    projectionName() {
      return `CYTO-${this.image.id}`;
    },
    baseLayerURL() {
      return Cytomine.instance.host + Cytomine.instance.basePath + `abstractslice/${this.slice.id}/normalized-tile/zoom/{z}/tx/{x}/ty/{y}.jpg`;
    },
    tileLoadFunction() {
      return (tile, src) => {
        const xhr = new XMLHttpRequest();
        xhr.responseType = 'blob';
        xhr.open('GET', src);
        xhr.setRequestHeader('Authorization', 'Bearer ' + this.shortTermToken);
        xhr.addEventListener('load', () => {
          const url = URL.createObjectURL(xhr.response);
          const tileImage = tile.getImage();
          tileImage.addEventListener('load', () => URL.revokeObjectURL(url));
          tileImage.src = url;
        });
        xhr.send();
      }
    },
    extent() {
      return [0, 0, this.image.width, this.image.height];
    },
    imageSize() {
      return [this.image.width, this.image.height];
    },
    tileSize() {
      return this.image.tileSize;
    },
    maxZoom() {
      return this.image.zoom;
    },
    maxResolution() {
      return Math.pow(2, this.image.zoom);
    }

  },
  methods: {
    async fetchSlice() {
      let slices = (await AbstractSliceCollection.fetchAll({filterKey: 'abstractimage', filterValue: this.image.id})).array;
      this.slice = slices[0];
    },
  },
  async created() {
    await this.fetchSlice();
    this.center = [this.image.width/2, this.image.height/2];
    if(!getProj(this.projectionName)) { // if image opened for the first time
      let projection = createProj({code: this.projectionName, units: 'pixels', extent: this.extent});
      addProj(projection);
    }


    this.loading = false;
  }
};
</script>

<style scoped>
</style>
